import { Typography, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import "./MaintainancePage.scss"
import { navigateTo } from 'src/utils/navigateHelper';
import { ENDPOINTS } from 'src/constants';

// custom style for typography
const StyledTypography = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.dark};
  font-weight: bold;
`;
export default function MaintainancePage() {
    return (
        <div className="maintainance-page">
            <img src='/static/images/ppaEdge.png' alt="PPA Edge" className='maintainance-img' />
            <StyledTypography className='maintainance-message'>
                We are taking time out for <br /> tool enhancements and upgrades
                <StyledTypography className='maintainance-details'>
                    Sorry for inconvenience.
                    <br></br>
                    We will be back shortly
                </StyledTypography>
            </StyledTypography>
            <Button
                className="request-button"
                onClick={() => navigateTo(ENDPOINTS.homeUrl)}
            >
                Go to Home Page
            </Button>
        </div>
    );
}